import React from 'react'
import Layout from '../../components/layout/layout'
import './NotFound.css'

const NotFound = () => {
  return (
    <Layout>
      <h4 className="not-found-title">Not found page</h4>
    </Layout>
  );
}
 
export default NotFound;